(function( $ ) {
        var windowWidth = $(window).width();
        let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vh-init', `${vh}px`);
// We listen to the resize event
        window.addEventListener('resize', () => {
            if ($(window).width() == windowWidth) return;
            windowWidth = $(window).width();
            // We execute the same script as before
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });


    /**
     * Animate every link that goes to some anchor
     */
    $(function() {
        $('a[href*=#]:not([href=#])').not($(".navbar-nav")).click(function() {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 50
                    }, 700);
                    return false;
                }
            }
        });
    });


    $(document).ready(function() {
        $("p, h1, h2, h3, h4, h5, h6, span, .p").each(function() {
            let node = this;
            $(node).contents().each(function() {
                if (this.nodeType === 3) { // Zpracováváme pouze textové uzly, ne HTML tagy
                    this.nodeValue = this.nodeValue.replace(/\b(k|s|v|z|o|u|a|i|ke|ve|ze|do|po|na|od|pod|nad|při|za|ale|aby|že|když|jestli|než|protože|pokud)\s/g, "$1\u00A0");
                }
            });
        });
    });


})(jQuery);